import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shared-footer',
  templateUrl: 'shared-footer.component.html'
})

export class SharedFooterComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
